import axios from "axios";
import * as staticApi from "./static-api";

const STATIC = process.env.REACT_APP_STATIC === "1";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = STATIC ? staticApi.API : `${BASE}/api`;

export const api = STATIC
  ? staticApi.api
  : axios.create({
      baseURL: API,
      withCredentials: true,
    });

export function authHeader(token) {
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function formatApiError(err) {
  if (STATIC) return staticApi.formatApiError(err);
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  }
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
